import { render, staticRenderFns } from "./LanguageView.vue?vue&type=template&id=4a046d3c&scoped=true"
import script from "./LanguageView.vue?vue&type=script&lang=js"
export * from "./LanguageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a046d3c",
  null
  
)

export default component.exports